(ns ui.toast
  (:require
   ["@radix-ui/react-toast" :as RadixToast]
   [ui.button :as button]
   [ui.utils :refer [clsx]]))

(defn title-string [type]
  (case type
    :error "Error!"
    :warning "Warning!"
    :success "Success!"
    "Notification"))

(defn toast [{:keys [id active type message title metadata on-close on-close-all active-snacks-count data-cy]}]
  [:> RadixToast/Root
   {:onOpenChange (fn [open?]
                    (when-not open?
                      (on-close)))
    :type "background"
    :class (clsx
            "z-1800 fixed bottom-4 inset-x-4 w-auto md:bottom-4 md:left-4 md:right-auto md:top-auto md:w-full md:max-w-xl shadow-lg rounded-lg",
            "bg-white dark:bg-gray-800",
            "radix-state-open:animate-toast-slide-in-bottom md:radix-state-open:animate-toast-slide-in-left",
            "radix-state-closed:animate-toast-hide",
            "radix-swipe-direction-right:radix-swipe-end:animate-toast-swipe-out-x",
            "radix-swipe-direction-right:translate-x-radix-toast-swipe-move-x",
            "radix-swipe-direction-down:radix-swipe-end:animate-toast-swipe-out-y",
            "radix-swipe-direction-down:translate-y-radix-toast-swipe-move-y",
            "radix-swipe-cancel:translate-x-0 radix-swipe-cancel:duration-200 radix-swipe-cancel:ease-[ease]",
            "focus:outline-hidden focus-visible:ring-3 focus-visible:ring-purple-500/75"
            (case type
              :success "bg-kleene-primary-05 text-kleene-primary-v2"
              :error   "bg-kleene-error-05 text-kleene-error-01"
              :info    "bg-kleene-background-secondary text-kleene-text-secondary"
              "bg-kleene-warning-05 text-kleene-warning-01"))}
   [:div {:class "flex" :data-cy data-cy}
    [:div {:class "w-0 flex-1 flex items-center pl-5 py-4"}
     [:div {:class "w-full radix"}
      ;; TODO: update toast model to support notification titles
      [:> RadixToast/Title {:class "text-sm font-medium"} (or title (title-string type))]
      (when (not-empty message)
        [:> RadixToast/Description {:class "mt-1 text-sm break-words"}
         [:p message]
         (when-let [code (:code metadata)]
           [:div {:class "text-xs p-1 bg-kleene-text-error/10 rounded mt-2"}
            [:code  code]])])]]
    [:div {:class "flex"}
     [:div {:class "flex flex-col ml-4 px-3 py-2 space-y-1"}
      ;; TODO: add support for additional action buttons
      ;; We can add them through metadata and they should have a title and an
      ;; event that will be called when clicked.
      ;; Additional action will go here
      #_[:div {:class "h-0 flex-1 flex"}
         [:> RadixToast/Action {:alt-text ""
                                :on-click nil
                                :class "w-full border border-transparent rounded-lg px-3 py-2 flex items-center justify-center text-sm font-medium text-purple-600 dark:text-purple-500 hover:bg-gray-50 dark:hover:bg-gray-900 focus:z-10 focus:outline-hidden focus-visible:ring-3 focus-visible:ring-purple-500/75"}]]
      [:div {:class "h-0 flex-1 flex gap-0.5"}
       (when on-close-all
         [:> RadixToast/Close {:class "w-full border border-transparent rounded-lg px-3 py-2 flex items-center justify-center text-sm font-medium  focus:z-10 focus:outline-hidden focus-visible:ring-3 focus-visible:ring-purple-500/75 whitespace-nowrap"
                               :on-click on-close-all}
          "Dismiss all (" active-snacks-count ")"])

       [:> RadixToast/Close {:class "w-full border border-transparent rounded-lg px-3 py-2 flex items-center justify-center text-sm font-medium  focus:z-10 focus:outline-hidden focus-visible:ring-3 focus-visible:ring-purple-500/75"}
        "Dismiss"]]]]]])

(defn toast-container [toasts]
  (-> [:> RadixToast/Provider {:class "z-1999"
                               :swipe-direction "right"}]
      (into toasts)
      (into [[:> RadixToast/Viewport {:class "fixed left-0 bottom-0 z-1999"}]])))
